import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useGetResourceTags } from '@/shared/hooks/task/useGetResourceTags';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import MultiSelect, { splitItems } from '../multiselect/MultiSelect';
import { getTagColorKey } from '@/shared/components/tag/tagColors';
export const ResourceTagsMultiSelect = ({ selectedItems, placeholder, onChange, onFilterBehaviourChanged, filterBehaviour, withFilterBehaviour, }) => {
    const { data } = useGetResourceTags();
    const relationLabels = data === null || data === void 0 ? void 0 : data.map(x => ({ id: x.id, label: x.name, sort: x.name.toLowerCase(), color: x.color })).sort(dynamicSort('sort'));
    const [selectedLabels, availableLabels] = splitItems(relationLabels, selectedItems, 'label');
    return (_jsx(MultiSelect, { selectedItem: selectedLabels, onItemRemoved: item => onChange(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.filter(label => label !== item.value.label)), onItemSelected: item => onChange([...(selectedItems !== null && selectedItems !== void 0 ? selectedItems : []), item.label]), items: availableLabels, placeholder: placeholder, itemClassNameFunc: item => `tag-color-${getTagColorKey(item.color)}`, onFilterBehaviourChanged: (behaviour) => onFilterBehaviourChanged(behaviour), filterBehaviour: filterBehaviour, withFilterBehaviour: withFilterBehaviour }));
};
export const FilterResourceTagsMultiSelect = ({ item, setFilter, activeFilters, label, isAlwaysVisible, withFilterBehaviour, enabled, }) => {
    var _a;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(ResourceTagsMultiSelect, { onChange: value => {
                var _a;
                setFilter({
                    [item]: ((_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0) > 0 ? value : undefined,
                });
            }, selectedItems: activeFilters[item], placeholder: label, onFilterBehaviourChanged: filterBehaviour => {
                setFilter({
                    filterBehaviours: {
                        [item]: filterBehaviour,
                    },
                });
            }, filterBehaviour: (_a = activeFilters.filterBehaviours) === null || _a === void 0 ? void 0 : _a[item], withFilterBehaviour: withFilterBehaviour })),
    });
};
